
export default
{
  'domain': process.env.VUE_APP_AUTH0_DOMAIN ? process.env.VUE_APP_AUTH0_DOMAIN : "auth.dev.wheezo.com",
  'clientId': process.env.VUE_APP_AUTH0_CLIENT_ID ? process.env.VUE_APP_AUTH0_CLIENT_ID : "KLC0aYY2Etvk9vO9CQxKlCcasisazxQf",
  'audience': process.env.VUE_APP_AUTH0_AUDIENCE ? process.env.VUE_APP_AUTH0_AUDIENCE : "https://api-dev.wheezo.com"
}